import AT from 'images/icons/flag-full/AT.png';
import BE from 'images/icons/flag-full/BE.png';
import BG from 'images/icons/flag-full/BG.png';
import CH from 'images/icons/flag-full/CH.png';
import CY from 'images/icons/flag-full/CY.png';
import CZ from 'images/icons/flag-full/CZ.png';
import DE from 'images/icons/flag-full/DE.png';
import DK from 'images/icons/flag-full/DK.png';
import EE from 'images/icons/flag-full/EE.png';
import ES from 'images/icons/flag-full/ES.png';
import FI from 'images/icons/flag-full/FI.png';
import FR from 'images/icons/flag-full/FR.png';
import GB from 'images/icons/flag-full/GB.png';
import GR from 'images/icons/flag-full/GR.png';
import HR from 'images/icons/flag-full/HR.png';
import HU from 'images/icons/flag-full/HU.png';
import IE from 'images/icons/flag-full/IE.png';
import IS from 'images/icons/flag-full/IS.png';
import IT from 'images/icons/flag-full/IT.png';
import LT from 'images/icons/flag-full/LT.png';
import LU from 'images/icons/flag-full/LU.png';
import LV from 'images/icons/flag-full/LV.png';
import NL from 'images/icons/flag-full/NL.png';
import NO from 'images/icons/flag-full/NO.png';
import PL from 'images/icons/flag-full/PL.png';
import PT from 'images/icons/flag-full/PT.png';
import RO from 'images/icons/flag-full/RO.png';
import SE from 'images/icons/flag-full/SE.png';
import SI from 'images/icons/flag-full/SI.png';
import SK from 'images/icons/flag-full/SK.png';

export default {
	AT,
	BE,
	BG,
	CH,
	CY,
	CZ,
	DE,
	DK,
	EE,
	ES,
	FI,
	FR,
	GB,
	GR,
	HR,
	HU,
	IE,
	IS,
	IT,
	LT,
	LU,
	LV,
	NL,
	NO,
	PL,
	PT,
	RO,
	SE,
	SI,
	SK,
};
